var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useEffect, useMemo, useCallback, useContext } from "react";
import { DigiThemeManagerContext } from "../digitheme/DigiThemeManager";
import ListField from "./ListField";

var DictionaryField = function DictionaryField(props) {
  var dictionaryConfig = props.dictionaryConfig,
      onValueChange = props.onValueChange,
      onDictionaryItemSelect = props.onDictionaryItemSelect;

  var digiThemeManagerContext = useContext(DigiThemeManagerContext);

  useEffect(function () {
    digiThemeManagerContext.loadDictionary(dictionaryConfig.uuid, dictionaryConfig.keyColumn, dictionaryConfig.valueColumn, dictionaryConfig.geomColumn);
  }, [dictionaryConfig]);

  var config = useMemo(function () {
    return digiThemeManagerContext.getDictionary(dictionaryConfig.uuid, dictionaryConfig.keyColumn, dictionaryConfig.valueColumn, dictionaryConfig.geomColumn);
  }, [dictionaryConfig]);

  var handleChange = useCallback(function (value) {
    onValueChange(value);
    if (onDictionaryItemSelect) {
      var item = config.find(function (i) {
        return i.key === value;
      });
      onDictionaryItemSelect(item, dictionaryConfig);
    }
  }, [onValueChange, onDictionaryItemSelect, config]);

  return config ? React.createElement(ListField, _extends({
    isDictionary: true,
    items: config
  }, props, {
    onValueChange: handleChange
  })) : React.createElement("div", { className: "loading" });
};

export default DictionaryField;